import axios from 'axios'
import { getNextPageUrl, pagination as importPagination, filters } from '../../../helpers/store'

const pagination = { ... importPagination, ...{ per_page: 15 }}

const state = {
  outletHistory: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  cbsAutoHistory: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  }
}

const mutations = {
  RESET_PAGINATION(state, key) {
    state[key].pagination = pagination
  },

  SET_BUSY(state, {key, value}) {
    if(!key) return state.isBusy = value
    state[key].isBusy = value
  },

  SET_INITIATE_STATE(state, {key, value}) {
    state[key].isInitiated = value
  },

  SET_PAGINATED_RESOURCE(state, {key, resourceData, pagination:responsePagination, reset = false}) {
    if(reset) {
      state[key].isInitiated = false
      state[key].data = []
      state[key].pagination = {...pagination}
    }
    resourceData.forEach(query => state[key].data.push(query))
    state[key].pagination = { ...state[key].pagination, ...responsePagination }
    state[key].isInitiated = true
  },

  PREPEND_HISTORY(state, log) {
    state.outletHistory.data.unshift(log)
  }
}

const getters = {
  outletHistoryCanLoadMore(state) {
    return state.outletHistory.isInitiated && !state.outletHistory.isBusy && state.outletHistory.pagination.page < state.outletHistory.pagination.total_pages
  },

  cbsAutoHistoryCanLoadMore(state) {
    return state.cbsAutoHistory.isInitiated && !state.cbsAutoHistory.isBusy && state.cbsAutoHistory.pagination.page < state.cbsAutoHistory.pagination.total_pages
  }
}

const actions = {
  // 1. getPaginatedResource
  getPaginatedResource({ commit, state: { project_id } }, {key, url, extraFilters = {}}) { // key is the resource you update in this file (e.g. "outletHistory",  "outlets" - paginated resource)
    let { page, total_pages, per_page } = state[key].pagination
    const localPagination = { page, per_page }
    const { filters } = state[key]

    return new Promise((resolve, reject) => {

      if(page && page >= total_pages) reject()

      commit('SET_BUSY', {key, value: true})

      // url is base either on the provide "url" or on "key": `projects/${project_id}/${key}`
      url = url ? url : `projects/${project_id}/${key}`

      axios.get(getNextPageUrl(url, localPagination, {...filters, ...extraFilters}))
        .then(({data : { status, data : { data: resourceData, pagination } }}) => {

          // reset pagination response to snake_case format
          pagination = {
            page: pagination.currentPage,
            total_count: pagination.totalCount,
            total_pages: pagination.totalPages,
            per_page: pagination.perPage || per_page
          }

          commit("SET_PAGINATED_RESOURCE", { key, resourceData, pagination, reset : pagination.page === 1})

          resolve()
        })
        .catch((e) => reject(e))
        .finally(() => {
          commit('SET_BUSY', {key, value: false})
          commit('SET_INITIATE_STATE', {key, value: true})
        })
    })
  },

  // when saving updates, prepend the new log to the beginning of the list
  prependHistory({ commit, state }, log) {
    commit('PREPEND_HISTORY', log)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};